export default {"src":"/_next/static/media/save.1972ebf2.svg","height":35,"width":153};